/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
import {ResetPassword} from './components/ResetPassword'
import {ForgotPassword} from './components/ForgotPassword'
import {VerifyEmail} from './components/VerifyEmail'
import {ResendEmail} from './components/ResendEmail'
import {Login} from './components/Login'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {AnimaCima, AnimaFadein} from '../../../_metronic/assets/animation/styles'
import {VerifyDevice} from './components/VerifyDevice'

const FILE_STORAGE = process.env.REACT_APP_URL_FILE_STORAGE || ''
const COMPANY = process.env.REACT_APP_COMPANY || ''

const AuthLayout = () => {
  const timestamp = new Date().getTime()

  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  //imagem do logo da empresa
  const [logoImage, setlogoImage] = useState(
    `${FILE_STORAGE}${COMPANY}/sys/params/company_logo_dark.png`
  )
  // erro de imagem
  function erroImagem() {
    setlogoImage(toAbsoluteUrl('/media/logos/logoblack.png'))
  }

  return (
    <div className='d-flex bg-dark flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'>
      {/* <div className='d-flex bg-azul flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'> */}
      {/* <div className='d-flex bg-verde-claro flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'> */}
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* begin::Wrapper */}
        <AnimaCima>
          <div className='w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'>
            {/* <div className='w-lg-500px bg-verde-claro rounded shadow-sm p-10 p-lg-15 mx-auto border border-dark'> */}
            <div className='d-flex flex-center flex-column flex-column-fluid p-10'>
              {/* begin::Logo */}
              <AnimaFadein>
                <a href='#' className='mb-12'>
                  <img
                    alt='Logo Empresa'
                    src={logoImage + '?' + timestamp}
                    className='mh-85px'
                    onError={erroImagem}
                    //src={toAbsoluteUrl('/media/logos/logoblack.png')}
                  />
                </a>
              </AnimaFadein>

              {/* end::Logo */}
            </div>
            <Outlet />
          </div>
        </AnimaCima>
        {/* end::Wrapper */}
      </div>

      <div className='d-flex flex-center flex-column-auto '>
        <div className='d-flex align-items-center fw-bold fs-6'>
          <AnimaFadein>
            <a href='https://ambipar.com' className='mb-12'>
              <img
                alt='Ambipar Response'
                // src={toAbsoluteUrl('/media/logos/logoblack.png')}
                src={toAbsoluteUrl('/media/logos/ambipar_response.png')}
                className='h-60px mb-5 mt-0'
              />
            </a>
          </AnimaFadein>
        </div>
      </div>
    </div>
  )
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='resetpassword' element={<ResetPassword />} />
      <Route path='forgotpassword' element={<ForgotPassword />} />
      <Route path='resendemail' element={<ResendEmail />} />
      <Route path={`verifyemail/*`} element={<VerifyEmail />} />
      <Route path={`verifydevice/*`} element={<VerifyDevice />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
